<template>
  <div class="general-wrapper">
    <Header>
      <template #title>
        <h4 class="qrw-heading-md pr-2"><span class="v1-grey-7-color">{{$t('navbar.stats')}}</span> {{ $t("navbar.stats_guests") }}</h4>
      </template>
      <template #actions>
        <v-date-picker v-model="range" mode="range" :locale="$i18n.locale" />
      </template>
    </Header>

    <PageContainer v-if="stats">
      <GeneralInfo :summary="summary" :previous="summary" v-if="summary" />

      <ClientsStatHistogram :chart="stats.chart" />
      <SmallHistogram
        :title="$t('stats_histogram.guests_title')"
        :dailyHistogram="stats.daily_histogram"
        :hourlyHistogram="stats.hourly_histogram"
      />
      <TopTenStatCard :top="stats.top" />
    </PageContainer>
  </div>
</template>
<script>
import ClientsStatHistogram from "@/components/stats/ClientsStatHistogram.vue";

import TopTenStatCard from "@/components/stats/TopTenStatCard.vue";
import SmallHistogram from "@/components/stats/SmallHistogram.vue";
import GeneralInfo from "@/components/stats/GeneralInfo.vue";

import StatsAPI from "@/api/stats";
import moment from "moment";

export default {
  components: {
    ClientsStatHistogram,

    TopTenStatCard,
    SmallHistogram,
    GeneralInfo,
  },
  data() {
    return {
      stats: null,
      busy: true,
      previous_summary: null,
      range: {
        start: moment().subtract(1, "month").toDate(),
        end: moment().toDate(),
      },
      summary: null,
    };
  },
  watch: {
    range: {
      handler() {
        this.fetchStats();
      },
      deep: true,
    },
  },
  methods: {
    fetchStats() {
      const start = moment(this.range.start).startOf("day").valueOf();
      const end = moment(this.range.end).endOf("day").valueOf();

      this.busy = true;

      StatsAPI.computeGuestsStats(this.cafe._id, start, end).then((resp) => {
        this.stats = resp.stats;

        this.busy = false;
      });

      const period_length = moment(end).diff(moment(start), "days");

      StatsAPI.computeSummary(
        this.cafe._id,
        moment(start)
          // .subtract(period_length, "days")
          .valueOf(),
        moment(end)
          // .subtract(period_length, "days")
          .valueOf()
      ).then((data) => {
        this.summary = data.summary;
      });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  mounted() {
    this.fetchStats();
  },
};
</script>
<style scoped></style>
